

import Modal from 'react-modal';
import React, { Component } from 'react';
import ViewEnterpriseInformation from '../../NuevaSolicitudEmpresa/components/ViewEnterpriseInformation.jsx';
//import ViewAccountInformation from '../../NuevaSolicitudCuenta/components/ViewAccountInformation.jsx';
import Tarjetas from './Tarjetas/Tarjeta.jsx';
import Titulo from "./Titulo.jsx";
import Encabezado from "./Encabezado.jsx";
import Navegador from "./Navegador.jsx";
import Subtitulo from "./Subtitulo.jsx";
import Footer from "./Footer.jsx";


class ConfirmadorSolicitud extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        }

        this._dispatchToken = undefined;
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope, this.props.sesion);
    }

    componentWillUnmount() {
        this.props.resetStateConfirmadorSolicitud();
    }

    aceptModalPrincipal() {
        $('#okModalPrincipal').modal('toggle');
    }

    render() {
        let obj;
        const { data } = this.props.confirmadorSolicitud;
        if (data != undefined) {
            if (data.loading) {
                return <div className="loading"> Loading &#8230;</div>;
            }
            let body = undefined;
            let subTitulo = undefined;
            let entidad = undefined;
            let entidadTipo = undefined;

            if (data.entidad != undefined) {
                switch (data.entidad) {
                    case 0:
                        obj = {
                            atlasCategoriaIva: data.atlasCategoriaIva,
                            idEmpresaInformacion: data.empresa.Id,
                            empresas: [],
                            novedades: [],
                            rubros: data.rubros
                        }
                        obj.empresas.push(data.empresa);
                        body = <ViewEnterpriseInformation
                            data={obj}
                            ocultarFooter={true}
                            globalState={this.props.globalState}
                            currentScope={this.props.currentScope}
                            cerrarModal={this.props.cerrarModal}
                        />

                        subTitulo = data.empresa.Descripcion;
                        entidad = "de la empresa";
                        entidadTipo = "empresa, cuenta y tarjeta"
                        break;
                    case 1:
                        // body = <ViewAccountInformation
                        //     ocultarFooter={true}
                        //     cuentaInfo={data.cuentas[0]}
                        //     cerrarModal={this.cerrarModal} />

                        subTitulo = data.cuentas[0].Descripcion;
                        entidad = "de la cuenta";
                        entidadTipo = "cuenta y tarjeta"
                        break;
                    case 2:
                        body = <Tarjetas tarjetas={data.tarjetas}
                            modalidadDistribucionLimiteId={data.cuentas[0].ModalidadDistribucionLimiteId}
                            limiteCompraCodigo={data.cuentas[0].LimiteCompraCodigo }
                            cerrarModal={this.cerrarModal}  />
                        //subTitulo = data.tarjetas[0].ClienteNombre + " " + data.tarjetas[0].ClienteApellido;
                        entidad = "de Tarjetas";
                        entidadTipo = "tarjeta"
                        break;
                    default:
                        body = null
                        break;
                }
            }

            return (
                <div className="container-fluid">
                    <Titulo titulo={data.razonSocial}
                        entidadTipo={entidadTipo} />
                    <Encabezado data={data} />                  
                    <Navegador data={data}
                        goTo={this.props.goTo} />
                    <Subtitulo entidad={entidad}
                        subTitulo={subTitulo} />               
                    {body}               
                    <Footer data={data}
                        goTo={this.props.goTo}
                        cambiarEstado={this.props.cambiarEstado}
                        cerrarModal={this.props.cerrarModal}/>
                </div>
            );
        }
        else {
            return <div className="loading"> Loading &#8230;</div>;
        }
    }
}

export default ConfirmadorSolicitud;